var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
export default /*#__PURE__*/React.memo(function SvgSpinnerArrow20Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    role: "presentation",
    "data-ignore-dark-theme-adapter": true
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1v2a7 7 0 1 1-7 7H1a9 9 0 1 0 9-9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.523 11.613 9.361 8.75H7.697a1.25 1.25 0 1 1 0-2.5h4.714c.69 0 1.25.56 1.25 1.25v4.675a1.25 1.25 0 1 1-2.5 0V10.55l-2.838 2.837a1.25 1.25 0 0 1-1.762-1.762z",
    className: "arrow"
  })));
});